import React, { useEffect, Fragment } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import beam from "../assets/sampleDrawings/BEAM-1.pdf";
import column from "../assets/sampleDrawings/COLUMN-1.pdf";
import verticalBrace from "../assets/sampleDrawings/VERTICAL-BRACE.pdf";
import gaurdRail from "../assets/sampleDrawings/GAURDRAIL.pdf";
import stair from "../assets/sampleDrawings/STAIR-A.pdf";
import wallRail from "../assets/sampleDrawings/WALLRAIL.pdf";
import ladder from "../assets/sampleDrawings/LADDER.pdf";
import anchorBolt from "../assets/sampleDrawings/ANCHOR-BOLT-SECTION.pdf";
import stairSections from "../assets/sampleDrawings/STAIR-SECTIONS.pdf";
import anchorBoltPlan from "../assets/sampleDrawings/ANCHOR-BOLT-PLAN.pdf";
import stairElevation from "../assets/sampleDrawings/STAIR-ELEVATION.pdf";
import section from "../assets/sampleDrawings/SECTIONS.pdf";
import elevation from "../assets/sampleDrawings/ELEVATION.pdf";
import framingPlan from "../assets/sampleDrawings/FRAMING-PLAN.pdf";
import stairPlan from "../assets/sampleDrawings/STAIR-PLAN.pdf";
import ladder1 from "../assets/sampleDrawings/LADDER-1.pdf";

import beamImg from "../assets/sampleDrawings/BEAM-1.JPG";
import columnImg from "../assets/sampleDrawings/COLUMN-1.JPG";
import verticalBraceImg from "../assets/sampleDrawings/VERTICAL-BRACE.JPG";
import gaurdRailImg from "../assets/sampleDrawings/GAURDRAIL.JPG";
import stairImg from "../assets/sampleDrawings/STAIR-A.JPG";
import wallRailImg from "../assets/sampleDrawings/WALLRAIL.JPG";
import ladderImg from "../assets/sampleDrawings/LADDER.JPG";
import anchorBoltImg from "../assets/sampleDrawings/ANCHOR-BOLT-SECTION.JPG";
import stairSectionsImg from "../assets/sampleDrawings/STAIR-SECTIONS.JPG";
import anchorBoltPlanImg from "../assets/sampleDrawings/ANCHOR-BOLT-PLAN.JPG";
import stairElevationImg from "../assets/sampleDrawings/STAIR-ELEVATION.JPG";
import sectionImg from "../assets/sampleDrawings/SECTIONS.JPG";
import elevationImg from "../assets/sampleDrawings/ELEVATION.JPG";
import framingPlanImg from "../assets/sampleDrawings/FRAMING-PLAN.JPG";
import stairPlanImg from "../assets/sampleDrawings/STAIR-PLAN.JPG";
import ladder1Img from "../assets/sampleDrawings/LADDER-1.JPG";
import "../style/DocumentList.css";

const detailDocuments = [
  { title: "BEAM", file: beam, thumbnail: beamImg },
  { title: "COLUMN", file: column, thumbnail: columnImg },
  {
    title: "VERTICAL BRACE",
    file: verticalBrace,
    thumbnail: verticalBraceImg,
  },
  {
    title: "GAURDRAIL",
    file: gaurdRail,
    thumbnail: gaurdRailImg,
  },
  { title: "STAIR A", file: stair, thumbnail: stairImg },
  {
    title: "WALL RAIL",
    file: wallRail,
    thumbnail: wallRailImg,
  },
  { title: "LADDER", file: ladder, thumbnail: ladderImg },
];

const erectionDocuments = [
  {
    title: "ANCHOR BOLD SECTION",
    file: anchorBolt,
    thumbnail: anchorBoltImg,
  },
  {
    title: "STAIR SECTIONS",
    file: stairSections,
    thumbnail: stairSectionsImg,
  },
  {
    title: "ANCHOR BOLD PLAN",
    file: anchorBoltPlan,
    thumbnail: anchorBoltPlanImg,
  },
  {
    title: "STAIR ELEVATION",
    file: stairElevation,
    thumbnail: stairElevationImg,
  },
  { title: "SECTION", file: section, thumbnail: sectionImg },
  {
    title: "ELEVATION",
    file: elevation,
    thumbnail: elevationImg,
  },
  {
    title: "FRAMING PLAN",
    file: framingPlan,
    thumbnail: framingPlanImg,
  },
  {
    title: "STAIR PLAN",
    file: stairPlan,
    thumbnail: stairPlanImg,
  },
  { title: "LADDER", file: ladder1, thumbnail: ladder1Img },
];

const DocumentList = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Fragment>
      <div className="document-container">
        <h2 className="document-title">DETAIL SHEETS</h2>
        <div className="document-list">
          {detailDocuments.map((doc, index) => (
            <div className="document-card" key={index} data-aos="fade-up" data-aos-duration="1000">
              <img src={doc.thumbnail} alt={doc.title} className="thumbnail" />
              <p className="doc-title">{doc.title}</p>
              <a href={doc.file} download className="download-button">
                Download
              </a>
            </div>
          ))}
        </div>
      </div>

      <div className="document-container">
        <h2 className="document-title">ERECTION SHEETS</h2>
        <div className="document-list">
          {erectionDocuments.map((doc, index) => (
            <div className="document-card" key={index} data-aos="fade-up" data-aos-duration="1000">
              <img src={doc.thumbnail} alt={doc.title} className="thumbnail" />
              <p className="doc-title">{doc.title}</p>
              <a href={doc.file} download className="download-button">
                Download
              </a>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default DocumentList;
